'use strict';

angular.module('route', []);
